<template>
    <v-row>
        <v-col cols="12" >
            <v-list>
                 <show-field :value="$t('delivery.states.'+item.state)" :label="$t('delivery.orderState.labels.state')" icon="checklist"/>
              <show-field :value="item.takeAwayMessage" :label="$t('delivery.orderState.labels.takeAwayMessage')" icon="store"/>
              <show-field :value="item.deliveryMessage" :label="$t('delivery.orderState.labels.deliveryMessage')" icon="delivery_dining"/>

            </v-list>
        </v-col>


    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'


    export default {
        name: 'OrderStateShowData',
        components: {ShowField},

        props: {
            item: {type: Object, required: true}
        }
    }
</script>

